import { StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';

const styles = StyleSheet.create({
    buttonWatch: {
        height: 40,
        borderRadius: 99,
        justifyContent: 'center',
        alignItems: 'center',
    },
    buttonWatchProgress: {
        position: 'absolute',
        top: 0,
        left: 0,
        height: 40,
        backgroundColor: COLOR.BLACK,
        opacity: 0.4,
        borderTopLeftRadius: 4,
        borderBottomLeftRadius: 4,
    },
});

export default styles;
